import React from 'react';
import { CompoundInterestSummaryFooterMetric } from './metric/compound-interest-summary-footer-metric';

interface CompoundInterestSummaryFooterProps {
    roiLabel: React.ReactNode;
    roiValue: React.ReactNode;
    roiValueStyle?: React.CSSProperties;
    taxAmountLabel: React.ReactNode;
    taxAmountValue: React.ReactNode;
    realValueLabel: React.ReactNode;
    realValue: React.ReactNode;
}

export const CompoundInterestSummaryFooter: React.FC<CompoundInterestSummaryFooterProps> = ({
    roiLabel,
    roiValue,
    roiValueStyle,
    taxAmountLabel,
    taxAmountValue,
    realValueLabel,
    realValue,
}) => (
    <div className="grid grid-cols-1 overflow-hidden rounded-b-[2.8rem] border border-[#d9cdc5] border-t-0 md:rounded-b-[3.6rem] [@media(min-width:1100px)]:grid-cols-3">
        <CompoundInterestSummaryFooterMetric label={roiLabel} value={roiValue} valueStyle={roiValueStyle} />
        <CompoundInterestSummaryFooterMetric label={taxAmountLabel} value={taxAmountValue} />
        <CompoundInterestSummaryFooterMetric label={realValueLabel} value={realValue} />
    </div>
);
